	<template>
		<div class="adminechart">
			<div class="pageTitle">{{bbs_name}}</div>
			<div class="custom_tag">
				<div :class="day_type==1?'leftdays tag_active':'leftdays'" @click="chioseDays(1)">今日</div>
				<div :class="day_type==2?'centerdaysd tag_active':'centerdaysd'" @click="chioseDays(2)">7日</div>
				<div :class="day_type==3?'centerdays tag_active':'centerdays'" @click="chioseDays(3)">30日</div>
				<div :class="day_type==4?'rightdays tag_active':'rightdays'" @click="chioseDays(4)">90日</div>
			</div>
			<div class="page_box">
				<div class="keyword_box">
					<van-row gutter="20" style="border-bottom:1px solid #EEEEEE;color: #666666;">
						<van-col span="6">论坛名称</van-col>
						<van-col span="6">发帖数量</van-col>
						<van-col span="6">阅读数量</van-col>
						<van-col span="6">回帖数量</van-col>
					</van-row>
					<div style="margin: 10px 0;">
						<van-row gutter="20" class="hot_list">
							<van-col span="6">{{bbs_name}}</van-col>
							<van-col span="6">{{number}}</van-col>
							<van-col span="6">{{read_num_all}}</van-col>
							<van-col span="6">{{comment_num_all}}</van-col>
						</van-row>
					</div>
				</div>
			</div>
			<div class="keyword_box" style="margin: 15px;">
				<div id="myChart" style="width: 95%;height:300px;margin-left: 12px;margin-top: 15px;"></div>
			</div>
		</div>
	</template>
	<script>
		import admin from '../../api/admin';
		import { mapState } from 'vuex';
		import { Col, Row,Search,Cell } from 'vant';
		export default {
			data () {
				return {
					bbs_name:'',
					number:'',
					read_num_all:'',
					comment_num_all:'',
					list:[],
					day_type:1
				}
			},
			computed: {
				...mapState({
					user: state => state.param.user
				})
			},
			mounted() {
				this.type = this.$route.params.type
				this.chioseDays(this.$route.params.type)
			},
			created () {
				this.type = this.$route.params.type
				this.bbs_type = this.$route.params.bbstype
				this.bbs_name = this.$route.params.name
				this.number = this.$route.params.number
				this.read_num_all = this.$route.params.readnum
				this.comment_num_all = this.$route.params.commentnum
				// this.chioseDays(1)
			},
			watch: {
				'$route'() {
					if(this.$route.params.type){
						if(this.$route.params.type != this.bbs_type) {
							this.type = this.$route.params.type
							this.bbs_type = this.$route.params.bbstype
							this.bbs_name = this.$route.params.name
							this.number = this.$route.params.number
							this.read_num_all = this.$route.params.readnum
							this.comment_num_all = this.$route.params.commentnum
							this.chioseDays(this.$route.params.type)
						}
					}

				}
			},
			methods: {
				chioseDays(day){
					this.day_type=day
					this.drawLine(day);
					// var params={
					// 	type:day
					// }
					// admin.getAdminhot(params).then(res => {
					// 	this.list=res.data.data
					// 	this.drawLine(day);
					// })
				},
				// drawLine(day){
				// 	let myChart = this.$echarts.init(document.getElementById('myChart'))
				// 	var params={
				// 		type:day,
				// 		bbs_type:this.bbs_type
				// 	}
				// 	admin.getEchartsList(params).then(res => {
				// 		var data=res.data.data.time
				// 		var series= [{
				// 			name: '发帖数量',
				// 			data:res.data.data.bbs_card,
				// 			type: 'line',
				// 			smooth: true,
				// 			itemStyle: {
				// 				color: '#303231'
				// 			},
				// 		},{
				// 			name: '阅读数量',
				// 			data: res.data.data.read_num,
				// 			type: 'line',
				// 			smooth:true,
				// 			itemStyle: {
				// 				color: '#303231'
				// 			},
				// 		},{
				// 			name: '回帖数量',
				// 			data: res.data.data.comment_num,
				// 			type: 'line',
				// 			smooth: true,
				// 			itemStyle: {
				// 				color: '#303231'
				// 			},
				// 		}]
				// 		myChart.setOption({
				// 			tooltip: {
				// 				trigger: 'axis'
				// 			},

				// 			xAxis: {
				// 				type: 'category',
				// 				boundaryGap: false,
				// 				data: data
				// 			},
				// 			yAxis: {
				// 				type: 'value'
				// 			},
				// 			legend: {
				// 				data:['发帖数量','阅读数量','回帖数量']
				// 			},
				// 			series:series
				// 		});
				// 	})
				// }
			},
			components: {
				[Col.name]: Col,
				[Row.name]: Row,
				[Search.name]:Search,
				[Cell.name]:Cell
			}
		}
	</script>
	<style lang="scss">
	.adminechart{
		.page_box{
			padding:15px;
		}
		.bbs_hot{
			border-top:10px solid #F8F8F8;
			.pageTitle{
				display: flex;
			}
		}
		.keyword_box{
			border: 1px solid #BBBBBB;
			border-radius: 4px;
			font-size:12px;
		}
		.van-row{
			padding:15px;
			color:#000000;
			align-items: center;
			display: flex;
			.van-col{
				text-align: center;
			}
			.green{
				color: #2B8600;
			}
			.red{
				color: #E02020;
			}
		}
		.custom_tag{
			display: flex;
			background-color: #ffffff;
			font-size: 12px;
			justify-content: center;
			margin: 15px;
			.leftdays{
				padding:3px 12px;
				color: #000000;
				border:1px solid #EEEEEE;
				border-top-left-radius:4px;
				border-bottom-left-radius:4px;
			}
			.centerdaysd{
				padding:3px 12px;
				color: #000000;
				border-right:1px solid #EEEEEE;
				border-top:1px solid #EEEEEE;
				border-bottom:1px solid #EEEEEE;
			}
			.centerdays{
				padding:3px 12px;
				color: #000000;
				border-top:1px solid #EEEEEE;
				border-bottom:1px solid #EEEEEE;
			}
			.rightdays{
				padding:3px 12px;
				color: #000000;
				border:1px solid #EEEEEE;
				border-top-right-radius:4px;
				border-bottom-right-radius:4px;
			}
			.tag_active{
				border:1px solid #007CDA;
				background-color:#007CDA;
				color: #fff;
			}
		}
		
	}
</style>
